import React, { useState } from "react";
import Technologies from "../components/Technologies";
import SkillsData from "../exports/Skills";

function SkillSets() {
  const [hoveredSkillSet, setHoveredSkillSet] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
      <div className="w-full mx-auto">
        <div className="flex flex-row items-start flex-wrap">
          {SkillsData.map((skillSet, index) => (
            <div
              key={index}
              className={`w-full sm:mx-15 overflow-hidden rounded-3xl group-hover:text-black mx-4 mb-8 ${
                window.innerWidth <= 768 && activeIndex === index
                  ? "expanded"
                  : ""
              }`}
              onMouseEnter={() => setHoveredSkillSet(skillSet.skillSet)}
              onMouseLeave={() => setHoveredSkillSet(null)}
              onClick={() => {
                setActiveIndex(index);
              }}
            >
              <div
                className={`block p-4 bg-zinc-900 overflow-hidden relative group italic cursor-pointer`}
              >
                <div
                  className={`transform scale-100 group-hover:scale-200 ${
                    window.innerWidth <= 768 && activeIndex === index
                      ? "scale-200"
                      : ""
                  } transition-transform h-32 w-36 ${
                    skillSet.color
                  } absolute -top-20 -right-20 rounded-full duration-500 ease-in-out`}
                  style={{
                    transform: `scale(${
                      hoveredSkillSet === skillSet.skillSet ||
                      (window.innerWidth <= 768 && activeIndex === index)
                        ? 35
                        : 1
                    })`,
                  }}
                ></div>
                <div
                  className={`group-hover:text-black transition-colors overflow-hidden font-bold text-lg md:text-2xl text-white relative z-10`}
                >
                  {skillSet.skillSet}
                </div>
                {window.innerWidth > 768 ||
                (window.innerWidth <= 768 && activeIndex === index) ? (
                  <div className="flex flex-wrap flex-row text-white relative">
                    {skillSet.technologies.map((technology, index) => (
                      <div key={index} className="p-1">
                        <Technologies
                          Icon={technology.icon}
                          Text={technology.name}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default SkillSets;
